import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep9 = (state) => state.get('step9');

const makeSelectStep9 = () =>
  createSelector(selectStep9, (step9State) => ({
    areYouClaimingForRentalVehicleExcess: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'areYouClaimingForRentalVehicleExcess']),
      ''
    ),
    nameOfThePersonDrivingTheCar: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'nameOfThePersonDrivingTheCar']),
      ''
    ),
    driverDateOfBirth: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'driverDateOfBirth']),
      ''
    ),
    dateOfExpense: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'dateOfExpense']),
      ''
    ),
    description: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'description']),
      ''
    ),
    rentalVehicleExcessAmount: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'rentalVehicleExcessAmount']),
      ''
    ),
    rentalVehicleExcessAmountCurrency: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'rentalVehicleExcessAmountCurrency']),
      ''
    ),
    actualRepairAmount: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'actualRepairAmount']),
      ''
    ),
    actualRepairAmountCurrency: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'actualRepairAmountCurrency']),
      ''
    ),
    amountClaimed: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'amountClaimed']),
      ''
    ),
    amountClaimedCurrency: mapWithDefault(
      step9State,
      () => step9State.getIn(['form', 'amountClaimedCurrency']),
      ''
    ),
  }));

const makeSelectStep9Errors = () =>
  createSelector(selectStep9, (state) => state.get('errors'));

export { makeSelectStep9, makeSelectStep9Errors };



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step9/selectors.js